import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocList } from 'commons/components/components-wrapper/poc-list.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { DEACTIVATE_FILTER_PARAM } from 'commons/hooks/create-filter-context';
import { useTranslation } from 'core/i18n';
import { SideMenuListItem } from '../app.menu.style';
import { MenuProps } from '../app.menu.type';

const LOTS_INACTIVE_MENU_VALUE = `lots/filters/${DEACTIVATE_FILTER_PARAM}`;

export const LotsMenu: React.FC<MenuProps> = ({ selected, menuVisible, onNavigationClick, onExpandedChange }) => {
    const { t } = useTranslation();

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        if ((e.target as HTMLElement).closest('owc-icon-button')) {
            return;
        }
        onNavigationClick('lots');
    };

    const handleExpand = () => {
        onExpandedChange?.(!menuVisible);
    };

    return (
        <SideMenuListItem
            value="lots"
            data-testid="lots-menu-item"
            variant="side-menu"
            selected={selected === `lots`}
            onClick={handleClick}
            onExpandedChange={handleExpand}
            size="medium"
            expanded={menuVisible}
        >
            <PocIcon slot="prefix" name="materials" family="filled" data-testid="lots-menu-icon" />
            {t('app.sidemenu.options.lots')}
            <PocList slot="children">
                <PocListItem
                    variant="side-menu"
                    data-testid="lots-inactive-menu-item"
                    value={LOTS_INACTIVE_MENU_VALUE}
                    size="medium"
                    className={selected === LOTS_INACTIVE_MENU_VALUE ? 'selected' : ''}
                >
                    {t('app.sidemenu.options.lots.inactive')}
                </PocListItem>
            </PocList>
        </SideMenuListItem>
    );
};
